// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2da6d2b4","239":"d9cbbeab","488":"bcd23c50","667":"de1be549"}[chunkId] + ".chunk.js";
};